export default __webpack_public_path__ + "img/angle-up.3a9b6300.svg";